import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"
import { Skeleton } from "@/components/ui/skeleton"
import { cn } from "cn"

/** Loading placeholder that keeps a card's title + height while data loads. */
export function InsightCardSkeleton({
  title,
  description,
  className,
  variant = "chart",
}: {
  title: string
  description?: string
  className?: string
  variant?: "chart" | "list" | "table"
}) {
  return (
    <Card className={cn(variant === "chart" && "min-h-90", className)} aria-busy="true">
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        {description && <CardDescription>{description}</CardDescription>}
      </CardHeader>
      <CardContent className="flex min-h-0 flex-1 flex-col gap-3">
        {variant === "chart" ? (
          <>
            <Skeleton className="h-8 w-40" />
            <Skeleton className="min-h-40 w-full flex-1" />
          </>
        ) : (
          Array.from({ length: variant === "table" ? 6 : 5 }, (_, i) => (
            <Skeleton key={i} className="h-6 w-full" />
          ))
        )}
      </CardContent>
    </Card>
  )
}

/** Centered empty-state message for use inside a card body. */
export function InsightEmpty({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) {
  return (
    <div
      className={cn(
        "flex min-h-24 flex-1 items-center justify-center rounded-lg border border-dashed px-4 py-6 text-center text-sm text-muted-foreground",
        className
      )}
    >
      {children}
    </div>
  )
}
